"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enums = exports.ELMTypes = exports.CQLTypes = exports.CalculatorTypes = void 0;
/**
 * @deprecated
 * Prefer importing interfaces directly from root `index` instead of entire type modules with all interfaces
 * TODO: remove this line for fqm-execution 2.0
 */
exports.CalculatorTypes = __importStar(require("./Calculator"));
exports.CQLTypes = __importStar(require("./CQLTypes"));
exports.ELMTypes = __importStar(require("./ELMTypes"));
exports.Enums = __importStar(require("./Enums"));
//# sourceMappingURL=index.js.map